import { render, staticRenderFns } from "./SelfieFaceTecCamera.vue?vue&type=template&id=4ca9b470"
import script from "./SelfieFaceTecCamera.vue?vue&type=script&lang=js"
export * from "./SelfieFaceTecCamera.vue?vue&type=script&lang=js"
import style0 from "./SelfieFaceTecCamera.vue?vue&type=style&index=0&id=4ca9b470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports